import { render, staticRenderFns } from "./FbInfoView.vue?vue&type=template&id=b9ed6cbc&scoped=true"
import script from "./FbInfoView.vue?vue&type=script&lang=js"
export * from "./FbInfoView.vue?vue&type=script&lang=js"
import style0 from "./FbInfoView.vue?vue&type=style&index=0&id=b9ed6cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ed6cbc",
  null
  
)

export default component.exports